import { AxiosError } from 'axios';
import { apiService } from '@shared/services/apiServices';
import { QMS_CATEGORY_LABELS } from '../constants/labels';
import qmsCategoryEndpoints from './qmsCategoryEndpoints';

export interface UpdateQmsCategoryStatusResult {
  success: boolean;
  error?: string;
  alreadyInStatus?: boolean;
}

const extractErrorMessage = (errorData: unknown): string => {
  if (!errorData) {
    return QMS_CATEGORY_LABELS.STATUS_ERROR_GENERIC;
  }
  if (typeof errorData === 'string') {
    return errorData;
  }
  if (typeof errorData === 'object') {
    const obj = errorData as { message?: string; error?: string };
    return obj.message ?? obj.error ?? QMS_CATEGORY_LABELS.STATUS_ERROR_GENERIC;
  }
  return QMS_CATEGORY_LABELS.STATUS_ERROR_GENERIC;
};

export const updateQmsCategoryStatusApiService = {
  updateStatus: async (params: {
    categoryId: string;
    isActive: boolean;
  }): Promise<UpdateQmsCategoryStatusResult> => {
    try {
      const result = await apiService.patchAPI(
        `${qmsCategoryEndpoints.CATEGORIES}/${params.categoryId}/status`,
        { isActive: params.isActive },
        { skipGlobalErrorRedirect: true }
      );

      if (!result.error || result.status === 204) {
        return { success: true };
      }

      const statusCode = result.status;
      switch (statusCode) {
        case 404:
          return { success: false, error: 'Kategoria nie została znaleziona.' };
        case 409:
          return {
            success: false,
            alreadyInStatus: true,
            error: params.isActive
              ? QMS_CATEGORY_LABELS.STATUS_ERROR_ALREADY_ACTIVE
              : QMS_CATEGORY_LABELS.STATUS_ERROR_ALREADY_INACTIVE,
          };
        case 400:
          return {
            success: false,
            error: 'Proszę podać prawidłowe dane wejściowe.',
          };
        default:
          if (result.isNetworkError) {
            return {
              success: false,
              error: 'Błąd połączenia. Sprawdź połączenie internetowe.',
            };
          }
          return { success: false, error: extractErrorMessage(result.data) };
      }
    } catch (error) {
      if (!(error instanceof AxiosError)) {
        return {
          success: false,
          error:
            error instanceof Error
              ? error.message
              : QMS_CATEGORY_LABELS.STATUS_ERROR_GENERIC,
        };
      }
      const statusCode = error.response?.status;
      switch (statusCode) {
        case 404:
          return { success: false, error: 'Kategoria nie została znaleziona.' };
        case 409:
          return {
            success: false,
            alreadyInStatus: true,
            error: params.isActive
              ? QMS_CATEGORY_LABELS.STATUS_ERROR_ALREADY_ACTIVE
              : QMS_CATEGORY_LABELS.STATUS_ERROR_ALREADY_INACTIVE,
          };
        case 400:
          return {
            success: false,
            error: 'Proszę podać prawidłowe dane wejściowe.',
          };
        default:
          if (statusCode === undefined && error.request) {
            return {
              success: false,
              error: 'Błąd połączenia. Sprawdź połączenie internetowe.',
            };
          }
          return {
            success: false,
            error: extractErrorMessage(error.response?.data),
          };
      }
    }
  },
};
